import styled from "styled-components";

export const CircleToolControls = styled.div`
  position: absolute;
  top: 43px;
  right: 10px;
  background-color: white;
  border: 1px solid #016F35;
  padding: 10px 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  width: 350px;
`;

export const Title = styled.h3`
  font: normal normal 600 12px/17px Open Sans;
  margin: 0;
  color: #707070;
`;

export const RangeContainer = styled.div`
  position: relative;
  width: 100%;
  padding-right: 10px;
  margin: 4px 0;
`;

export const RangeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const RangeInput = styled.input`
  width: 100%;
  -webkit-appearance: none;
  background: transparent;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 15px;
    height: 15px;
    background: #007842;
    border-radius: 50%;
    cursor: pointer;
    transform: translateY(-35%);
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  }

  &::-webkit-slider-runnable-track {
    height: 5px;
    background: linear-gradient(
      to right,
      #007842 ${(props) => props.valuePercent}%,
      #ccc ${(props) => props.valuePercent}%
    );
    border-radius: 5px;
  }
`;

export const RangeMarkers = styled.div`
  position: absolute;
  font: normal normal normal 12px/17px Open Sans;
  color: #707070;
  top: -12px;
  right: 10px;
`;

export const ValueDisplay = styled.span`
  display: block;
  text-align: left;
  color: #707070;
  font: normal normal 600 12px/17px Open Sans;
`;

export const SelectButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
`;

export const SelectButton = styled.button`
  padding: 7px 20px;
  background-color: #006f35;
  color: white;
  border: none;
  border-radius: 40px;
  font: normal normal normal 16px/20px Open Sans;
  cursor: pointer;

  &:hover {
    background-color: #388e3c;
  }
`;

export const CircleEnds = styled.div`
  position: absolute;
  width: 15px;
  height: 15px;
  background: #007842;
  border-radius: 50%;
  top: 58%;
`;

export const LeftCircle = styled(CircleEnds)`
  top: 4px;
  left: 2px;
`;